$(document).ready(function(){
  
  

  var now = new Date();
  var expireTime = now.getTime() + 1000*(3600*12);
  now.setTime(expireTime);
  

  var show_newsletter_popup = 0;
  
  if(document.cookie.indexOf('popup_newsletter=1') >= 0 && document.cookie.indexOf('popup_newsletter_block=1') <= 0){
    //var show_newsletter_popup = 1;
  }
  
  
  
  if(document.cookie.indexOf('popup_newsletter_block=1') >= 0){
   var  show_newsletter_popup = 0;
  }
  
  //console.log(show_newsletter_popup);
  
  
  //document.cookie = 'popup_newsletter=1; expires=; path=/';

  //console.log(document.cookie.indexOf('popup_newsletter=1'))

  if(show_newsletter_popup == 1){

    //alert(now.toGMTString());

    $("#popup-newsletter").show();
    $("body").css("overflow","hidden");
  	
  
  }

  $("#popup-newsletter-close").click(function(){
    $("#popup-newsletter").hide();
    $("body").css("overflow","auto");	
	
    document.cookie = 'popup_newsletter_block=1; expires='+now.toGMTString()+'; path=/';
  });


  $("#popup-newsletter .popup-image img").click(function(){
    document.cookie = 'popup_newsletter_block=1; expires='+now.toGMTString()+'; path=/';
    
    location.href='/collections/piscina';
  });
 
  
});


